import { Grid } from "@material-ui/core";
import { isStaffRole } from "@saleor/auth/hooks/useUserRole";
import {
  ContractsQuery,
  CustomerContractsQuery,
  useGetBusinessUnitQuery
} from "@saleor/graphql";
import { RelayToFlat } from "@saleor/types";
import { mapEdgesToItems } from "@saleor/utils/maps";
import React, { useMemo } from "react";

import SoldToFilter from "../SoldToFilter";
import SoldToFilterCustomer from "../SoldToFilterCustomer";
import SoldToSearchBar from "../SoldToSearchBar";

interface SoldToPageProps {
  children?: React.ReactNode;
  onchange: (value: string) => void;
  onReset?: () => void;
  searchId?: string;
  loading?: boolean;
  onFilterByCompanyIds?: (ids: string[]) => void;
  onFilterByContractId?: (
    id: string,
    gradeGram: string,
    materialCode: string
  ) => void;
  customerContracts?:
    | RelayToFlat<ContractsQuery["contracts"]>
    | RelayToFlat<CustomerContractsQuery["scgpCustomerContracts"]>;
  soldToExists?: boolean;
}

const SoldToPage: React.FC<SoldToPageProps> = ({
  children,
  onchange,
  onReset,
  searchId,
  loading,
  customerContracts,
  soldToExists,
  onFilterByCompanyIds,
  onFilterByContractId
}) => {
  const { data } = useGetBusinessUnitQuery({
    displayLoader: true
  });
  const businessUnits = useMemo(() => mapEdgesToItems(data?.businessUnits), [
    data?.businessUnits
  ]);
  const ppBusinessUnit = businessUnits?.filter(unit => unit.name === "PP");
  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={3}>
          <SoldToSearchBar
            onchange={onchange}
            onReset={onReset}
            searchId={searchId}
            dataFound={!!customerContracts?.length}
            soldToExists={soldToExists}
            loading={loading}
            isDomestic
          />
          {isStaffRole() &&
          soldToExists !== undefined &&
          businessUnits?.length ? (
            <SoldToFilter
              searchId={searchId}
              businessUnits={ppBusinessUnit}
              onFilterByCompanyIds={onFilterByCompanyIds}
              onFilterByContractId={onFilterByContractId}
            />
          ) : businessUnits?.length && soldToExists ? (
            <SoldToFilterCustomer
              businessUnits={ppBusinessUnit}
              onFilterByCompanyIds={onFilterByCompanyIds}
            />
          ) : null}
        </Grid>
        <Grid item xs={9}>
          {children}
        </Grid>
      </Grid>
    </>
  );
};
export default React.memo(SoldToPage);
